var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.9413C16.6054 13.8084 14.3133 14.2528 12 14.25C9.61275 14.25 7.335 13.785 5.25 12.9413M12 12H12.0075M15 7.5V6C15 5.60218 14.842 5.22064 14.5607 4.93934C14.2794 4.65804 13.8978 4.5 13.5 4.5H10.5C10.1022 4.5 9.72064 4.65804 9.43934 4.93934C9.15804 5.22064 9 5.60218 9 6V7.5H15ZM6.75 18H17.25C17.6478 18 18.0294 17.842 18.3107 17.5607C18.592 17.2794 18.75 16.8978 18.75 16.5V9C18.75 8.60218 18.592 8.22064 18.3107 7.93934C18.0294 7.65804 17.6478 7.5 17.25 7.5H6.75C6.35218 7.5 5.97064 7.65804 5.68934 7.93934C5.40804 8.22064 5.25 8.60218 5.25 9V16.5C5.25 16.8978 5.40804 17.2794 5.68934 17.5607C5.97064 17.842 6.35218 18 6.75 18Z",
    stroke: "#3F3F46",
    strokeOpacity: 0.86,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModules);
export default __webpack_public_path__ + "static/media/Modules.e710639798f5100d5669a49b00d8b139.svg";
export { ForwardRef as ReactComponent };